import { getCompleteName } from "../../../utils/misc";

import type { CalendarItemsListFilterValue } from "./CalendarItemsListFilter";

export const getCalendarItemsListFilterTagsMap = (
  filter?: CalendarItemsListFilterValue,
) => {
  const result = {};

  // tags by type
  const types = filter?.types || [];
  types.forEach((itemType) => {
    const key = `type-${itemType.uuid}`;
    const label = itemType.name;
    result[key] = {
      label,
      onDelete: () => ({
        ...filter,
        types: filter?.types.filter((item) => item.uuid !== itemType.uuid),
      }),
    };
  });

  // tags by staff
  const staff = filter?.staff || [];
  staff.forEach((itemStaff) => {
    const key = `staff-${itemStaff.userUuid}`;
    const label = getCompleteName(itemStaff.firstName, itemStaff.lastName);
    result[key] = {
      label,
      onDelete: () => ({
        ...filter,
        staff: filter?.staff.filter(
          (item) => item.userUuid !== itemStaff.userUuid,
        ),
      }),
    };
  });

  return result;
};
